import { themeColor } from './color'

export const border = {
  radius: {
    sm: 6,
    md: 10,
    lg: 16,
  },
  thin: '1px',
  normal: '2px',
  thick: '3px',
  dark: themeColor.slate20,
  light: themeColor.slate10,
  button: {
    radius: 8,
  },
  input: {
    radius: 8,
  },
  card: {
    radius: '12px',
  },
  dropdown: {
    radius: 10,
  },
  icon: {
    radius: {
      sm: 6,
      md: 10,
    }
  }
}
